// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React context
import { useMaterialUIController } from "context";

/**
 * Simple logout button for the bottom of the Sidenav.
 * Full width, 48px tall (easy to tap), icon + label, turns red on hover/focus.
 * When the desktop sidenav is collapsed it shows only the icon.
 */
function LogoutButton({ onClick }) {
  const [controller] = useMaterialUIController();
  const { miniSidenav, transparentSidenav, whiteSidenav, darkMode } = controller;

  const lightBackground = transparentSidenav || (whiteSidenav && !darkMode);

  return (
    <Button
      type="button"
      onClick={onClick}
      aria-label="Log out"
      startIcon={<Icon>logout</Icon>}
      sx={({ palette: { white, dark, error }, functions: { rgba }, breakpoints }) => ({
        width: "calc(100% - 32px)",
        minHeight: 48,
        mx: 2,
        my: 1,
        textTransform: "none",
        fontSize: "0.875rem",
        fontWeight: 500,
        justifyContent: "flex-start",
        borderRadius: "8px",
        color: lightBackground ? dark.main : white.main,
        border: `1px solid ${rgba(lightBackground ? dark.main : white.main, 0.3)}`,

        "&:hover, &:focus-visible": {
          color: white.main,
          backgroundColor: error.main,
          borderColor: error.main,
        },

        [breakpoints.up("xl")]: miniSidenav
          ? { justifyContent: "center", "& .MuiButton-startIcon": { m: 0 } }
          : {},
      })}
    >
      <MDBox
        component="span"
        display={{ xs: "inline", xl: miniSidenav ? "none" : "inline", color: "white !important" }}
      >
        Logout
      </MDBox>
    </Button>
  );
}

LogoutButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default LogoutButton;
